import Hash from './Hash';

export default Hash
export { Hash as Base }
